module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Loading'), _vm._v(" "), _c('NavBar', {
    attrs: {
      "title": _vm.navBar.title,
      "type": _vm.navBar.type,
      "tips": _vm.navBar.tips,
      "tipsColor": _vm.navBar.color
    }
  }, [_c('span', {
    staticClass: "top-back",
    attrs: {
      "slot": "left",
      "data-track": _vm.track
    },
    on: {
      "click": _vm.back
    },
    slot: "left"
  }, [_c('i', {
    staticClass: "back-icon",
    style: ({
      color: 'rgb(68, 68, 68)'
    })
  })]), _vm._v(" "), (_vm.routerName == 'question' || _vm.routerName == 'index') ? _c('div', {
    staticClass: "top-menu",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.lookProtocol
    },
    slot: "right"
  }, [_c('i', {
    staticClass: "menu-icon",
    style: ({
      color: 'rgb(68, 68, 68)'
    })
  })]) : _vm._e()]), _vm._v(" "), (_vm.showMe) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 598
// module chunks = 1